import Link from 'next/link';

interface CategoryWrapperProps {
  children: React.ReactNode;
  categoryName: string;
  itemsCount: number;
  isShowCount?: boolean;
  redirectToDetails: string;
}

export const CategoryWrapper = ({
  children,
  categoryName,
  itemsCount,
  redirectToDetails,
  isShowCount = true,
}: CategoryWrapperProps) => {
  if (!itemsCount) return null;

  return (
    <div className="flex flex-col gap-3 max-md:gap-0 w-full border-b border-grey-400">
      <div className="flex items-center justify-between max-md:min-h-7.5">
        <div className="flex gap-2 max-md:items-center">
          <p className="text-button-semibold max-md:!text-sm !leading-[150%] text-black">{categoryName}</p>
          {isShowCount && (
            <div className="flex items-center justify-center p-[2px] bg-grey-200 rounded-[4px] max-md:h-5.5 max-md:min-w-5.5">
              <p className="text-body-regular text-grey-700 !leading-[140%] text-button-regular min-w-[15px] text-center">
                {itemsCount}
              </p>
            </div>
          )}
        </div>
        <Link
          href={redirectToDetails}
          className="text-button-bold max-md:!text-sm max-md:!leading-[150%] text-blue-300 underline hover:no-underline"
        >
          See all results
        </Link>
      </div>
      {children}
    </div>
  );
};
